import React, { Component } from 'react';

import EditAppUploader from './EditAppUploader';
import EditPageContentPrints from './EditPageContentPrints';
import EditPageContentStores from './EditPageContentStores';

import TOOLS from '../../componentes/TOOLS';

class EditPageContent extends Component {
    constructor() {
        super();
        this.allContents = [];
        this.wideBanner64 = null;
        this.squareBanner64 = null;
        this.state = {
            message: "",
            lang: "",
            locationId: "",
            name: "",
            shortDescription: "",
            description: "",
            squareBanner: "https://appstore.escolhatecnologia.com.br/api/images/squareBanner.jpg",
            wideBanner: "https://appstore.escolhatecnologia.com.br/api/images/wideBanner.jpg",
            prints: [],
            News: [],
            Stores: []
        };
    }

    checkToken() {
        return new Promise(
            (resolve, reject) => {
                let token = window.localStorage.getItem("AUTH-X-TOKEN");
                resolve(token);
            }
        );
    }

    saveOnServer() {
        const app = this.state;
        const form = new FormData()
        form.append('id', this.props.appId);
        form.append('lang', app.lang);
        form.append('locationId', app.locationId);
        form.append('name', app.name);
        form.append('shortDescription', app.shortDescription);
        form.append('description', app.description);
        form.append('squareBanner', app.squareBanner);
        form.append('wideBanner', app.wideBanner);
        form.append('prints', JSON.stringify(app.prints));
        form.append('News', JSON.stringify(app.News));
        form.append('Stores', JSON.stringify(app.Stores));

        this.checkToken().then(token => {
            if (token) {
                form.append('AUTH-X-TOKEN', token);

                fetch(`${TOOLS.serverURL}/saveappcontent/`, {
                    method: "POST",
                    body: form
                })
                    .then(response => response.json())
                    .then(json => {
                        if (json.ok) {
                            this.setState({ message: "Salvo com sucesso!" });
                        } else {
                            this.setState({ message: "Falha ao salvar!" });
                        }
                    });
            } else {
                window.alert("Falha ao recuperar o token");
                return false;
            };
        });
    }

    deleteContentOnServer() {
        const app = this.state;
        const form = new FormData()
        form.append('id', this.props.appId);
        form.append('lang', app.lang);
        form.append('locationId', app.locationId);


        this.checkToken().then(token => {
            if (token) {
                form.append('AUTH-X-TOKEN', token);

                fetch(`${TOOLS.serverURL}/removeappcontent/`, {
                    method: "POST",
                    body: form
                })
                    .then(response => response.json())
                    .then(json => {
                        if (json.ok) {
                            window.alert("Excluido com sucesso!");
                        } else {
                            window.alert(json.message);
                        }
                    });
            } else {
                window.alert("Falha ao recuperar o token");
                return false;
            };
        });
    }

    changeContent(lang) {
        let emptyContent = {
            lang: lang,
            locationId: "",
            name: "",
            shortDescription: "",
            description: "",
            squareBanner: "https://appstore.escolhatecnologia.com.br/api/images/squareBanner.jpg",
            wideBanner: "https://appstore.escolhatecnologia.com.br/api/images/wideBanner.jpg",
            prints: [],
            News: [],
            Stores: []
        };

        let content = this.allContents.filter(content => { return (content.lang === lang) });

        if (content.length > 0) {
            console.log(content[0]);
            this.setState({ ...content[0] });
        } else {
            this.setState({ ...emptyContent });
        }
    }

    handleChangeSubmit(e) {
        e.preventDefault();
        this.setState({ message: "Aguarde..." });
        this.saveOnServer();
    }

    handleChangeCancel(e) {
        e.preventDefault();

        let emptyContent = {
            lang: "",
            locationId: "",
            name: "",
            shortDescription: "",
            description: "",
            squareBanner: "",
            wideBanner: "",
            prints: [],
            News: [],
            Stores: []
        };
        this.setState({ ...emptyContent });
    }

    handleChangeSquareBanner(e) {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {

            this.setState({
                squareBanner: reader.result
            });

            this.squareBanner64 = reader.result;
        }

        reader.readAsDataURL(file);
    }

    handleChangeWideBanner(e) {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {

            this.setState({
                wideBanner: reader.result
            });
            this.wideBanner64 = reader.result;
        }

        reader.readAsDataURL(file);
    }

    handleChange(e) {
        let obj = {};
        obj[e.target.name] = e.target.value;
        this.setState({ ...obj });
    }

    handleChangeLang(e) {
        let lang = e.target.value;

        this.changeContent(lang);
    }

    handleUploadSquareBanner(squareBanner) {
        this.setState({ squareBanner });
    }
    handleUploadWideBanner(wideBanner) {
        this.setState({ wideBanner });
    }

    handleChangePrints(newPrints) {
        this.setState({ prints: newPrints });
    }

    handleAddStore(Store) {
        let newStores = this.state.Stores;
        let newData = true;

        newStores.map(store => {
            if (store.id === Store.id) {
                store.url = Store.url;
                newData = false;
            }
            return null;
        })

        if (newData) {
            newStores.push(Store);
        }

        this.setState({ Stores: newStores });
    }

    handleRemoveStore(id) {
        let newStores = this.state.Stores.filter(store => (store.id !== id));

        this.setState({ Stores: newStores });
    }

    handleExcluir(e) {
        e.preventDefault();

        if (window.confirm(`Deseja Excluir (${this.state.locationId}/${this.state.lang})?`)) {
            this.deleteContentOnServer();
        }
    }

    componentWillMount() {
        this.allContents = this.props.contents;
        this.setState({ ...this.allContents[0] });
    }

    render() {
        return (
            <div>
                <div className="formContent">
                    <div className="card-title">App Corpo Lingua ({this.state.lang}) </div>

                    <div className="form-container">
                        <label htmlFor="lang">Lingua</label>
                        <select type="lang" name="lang" id="lang" onChange={this.handleChangeLang.bind(this)} value={this.state.lang} >
                            <option value="">Selecione</option>
                            <option value="pt">Português</option>
                            <option value="en">Inglês</option>
                            <option value="es">Espanhol</option>
                        </select>
                    </div>

                    <div className="form-container">
                        <label htmlFor="locationId">Id Localizado</label>
                        <input type="locationId" name="locationId" id="locationId" onChange={this.handleChange.bind(this)} value={this.state.locationId} />
                    </div>

                    <div className="form-container">
                        <label htmlFor="name">Nome Localizado</label>
                        <input type="name" name="name" id="name" onChange={this.handleChange.bind(this)} value={this.state.name} />
                    </div>
                    <div className="form-container">
                        <label htmlFor="shortDescription">Descrição Curta</label>
                        <textarea type="shortDescription" name="shortDescription" id="shortDescription" onChange={this.handleChange.bind(this)} value={this.state.shortDescription} ></textarea>
                    </div>
                    <div className="form-container">
                        <label htmlFor="description">Descrição Completa</label>
                        <textarea type="description" name="description" id="description" onChange={this.handleChange.bind(this)} value={this.state.description} ></textarea>
                    </div>
                    <div className="form-container">
                        <label>Banner Quadrado (500x350) </label>
                        <img className="uploader350px" src={this.state.squareBanner} alt="Banner Quadrado (500x350)" />
                        <EditAppUploader
                            appId={this.props.appId}
                            lang={this.state.lang}
                            typeUpload="squareBanner"
                            cssTag="uploader350px"
                            callBackUploadSuccess={this.handleUploadSquareBanner.bind(this)}
                        />
                    </div>
                    <div className="form-container">
                        <label htmlFor="wideBanner">Banner Wide (1024x350)</label>
                        <img className="uploader100" src={this.state.wideBanner} alt="Banner Wide (1024x350)" />
                        <EditAppUploader
                            appId={this.props.appId}
                            lang={this.state.lang}
                            typeUpload="wideBanner"
                            cssTag="uploader100"
                            callBackUploadSuccess={this.handleUploadWideBanner.bind(this)}
                        />
                    </div>

                    <EditPageContentPrints
                        appId={this.props.appId}
                        lang={this.state.lang}
                        prints={this.state.prints}
                        callBackChangePrints={this.handleChangePrints.bind(this)}
                    />

                    <div className="form-container">
                        <EditPageContentStores
                            stores={this.state.Stores}
                            callBackAddStore={this.handleAddStore.bind(this)}
                            callBackRemoveStore={this.handleRemoveStore.bind(this)}
                        />
                    </div>
                    <br />
                    <br />
                    <br />
                    <br />
                    <div className="form-container">
                        <button type="button" className="btn btn-primary" onClick={this.handleChangeSubmit.bind(this)}>Save</button>
                        <button type="button" className="btn btn-default" onClick={this.handleChangeCancel.bind(this)}>Cancel</button>
                        <button type="button" className="btn btn-default" onClick={this.handleExcluir.bind(this)}>Excluir</button>
                    </div>
                    <div className="form-container">{this.state.message}</div>
                </div>
            </div>
        );

    }
}

export default EditPageContent;



// WEBPACK FOOTER //
// ./src/adm/componentes/EditPageContent.js